import React, { useState } from 'react';
import axios from 'axios';
import './Contact.css';

const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export default function Contact() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const validate = () => {
    const nextErrors = {};
    if (!formData.name.trim()) nextErrors.name = 'Name is required.';
    if (!formData.email || !EMAIL_PATTERN.test(formData.email)) {
      nextErrors.email = 'Please enter a valid email address.';
    }
    if (!formData.message.trim()) nextErrors.message = 'Please write a message.';
    return nextErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError('');
    const nextErrors = validate();
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length > 0) return;

    setSubmitting(true);
    try {
      const apiKey = process.env.REACT_APP_ROONBASH_EMAIL_API_KEY;
      await axios.post(
        'https://portal.roonbash.com/api/email/contact',
        {
          name: formData.name,
          email: formData.email,
          subject: 'New project inquiry from roonbash.com',
          message: formData.message,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': apiKey,
          },
        }
      );
      setSubmitted(true);
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      setSubmitError(error.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section className="contact" id="contact">
      <div className="contact-inner">
        <div className="contact-copy">
          <div className="contact-eyebrow" data-reveal>CONTACT</div>
          <h2 data-reveal>Tell us where you want to grow.</h2>
          <p data-reveal>
            An AI calling agent, a product build, a marketing push, or a CRM setup that finally works: we reply within
            one business day with a clear next step.
          </p>
          <a href="mailto:info@roonbash.com" className="contact-email" data-reveal>info@roonbash.com</a>
        </div>

        <form className="contact-form" data-reveal onSubmit={handleSubmit} noValidate>
          <div className="contact-form-row">
            <div className="contact-field">
              <input
                type="text"
                placeholder="Your name"
                value={formData.name}
                onChange={handleChange('name')}
              />
              {errors.name && <p className="contact-field-error">{errors.name}</p>}
            </div>
            <div className="contact-field">
              <input
                type="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange('email')}
              />
              {errors.email && <p className="contact-field-error">{errors.email}</p>}
            </div>
          </div>
          <div className="contact-field">
            <textarea
              rows={5}
              placeholder="What do you need? AI, software, marketing, CRM, or all of it?"
              value={formData.message}
              onChange={handleChange('message')}
            />
            {errors.message && <p className="contact-field-error">{errors.message}</p>}
          </div>
          {submitError && <p className="contact-field-error">{submitError}</p>}
          {submitted && <p className="contact-success">Thanks! We'll be in touch within one business day.</p>}
          <button type="submit" className="contact-submit" data-magnetic disabled={submitting}>
            {submitting ? 'Sending…' : 'Start a project'}
          </button>
        </form>
      </div>
    </section>
  );
}
